import React from "react";
import styled from "styled-components";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMicrophone } from "@fortawesome/fontawesome-free-solid";
import { faMailBulk } from "@fortawesome/free-solid-svg-icons";
import {
  faF,
  faKiwiBird,
  faG,
  faCamera,
  faWifi,
} from "@fortawesome/free-solid-svg-icons";

const FirstFooter = () => {
  return (
    <FFWrapper>
      <FFGrid>
        <FFLeft>
          <h6>Are locking for</h6>
          <h5>Lorem inpsum</h5>
          <h6>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</h6>
        </FFLeft>
        <FFRight>
          <FFRightLeft>
            <h6>
              <FontAwesomeIcon icon={faMicrophone} /> <></>(123) 456-7890
            </h6>
            <h6>
              <FontAwesomeIcon icon={faMailBulk} /> <></>info@domain.com
            </h6>
          </FFRightLeft>
          <FFRightLeft>
            <h6>Social Media</h6>
            <h6>
              <FontAwesomeIcon icon={faF} /> <></>
              <FontAwesomeIcon icon={faKiwiBird} /> <></>
              <FontAwesomeIcon icon={faG} /> <></>
              <FontAwesomeIcon icon={faCamera} /> <></>
              <FontAwesomeIcon icon={faWifi} /> <></>
            </h6>
          </FFRightLeft>
        </FFRight>
      </FFGrid>
    </FFWrapper>
  );
};

export default FirstFooter;

const FFWrapper = styled.div`
  width: 100vw;
  height: 15vh;
  background-color: #2e3842;
  overflow-y: hidden;
`;
const FFGrid = styled.div`
  width: 80vw;
  height: 15vh;
  margin-top: 4vh;
  margin-left: 10vw;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(1, 1fr);

  @media screen and (orientation: portrait) {
    width: 90vw;
    margin-left: 5vw;
  }
`;

const FFLeft = styled.div`
  h6 {
    margin: 0;
    margin-left: 1vw;
    color: white;
    font-size: 0.9vw;
    font-weight: 300;
    @media screen and (orientation: portrait) {
      font-size: 1.1vh;
    }
  }

  h5 {
    margin: 0;
    margin-left: 1vw;
    color: white;
    font-size: 1.15vw;
    font-weight: 500;
    @media screen and (orientation: portrait) {
      font-size: 1.5vh;
    }
  }
`;

const FFRight = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(1, 1fr);

  transform: translateY(-2vh);

  align-items: center;
`;

const FFRightLeft = styled.div`
  h6 {
    margin: 0;
    margin-left: 1vw;
    color: white;
    font-size: 0.9vw;
    font-weight: 300;
    text-align: right;

    @media screen and (orientation: portrait) {
      font-size: 0.9vh;
      margin-right: 2vw;
    }
  }
`;
